import { render, staticRenderFns } from "./Page4.vue?vue&type=template&id=1a923760"
import script from "./Page4.vue?vue&type=script&lang=js"
export * from "./Page4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports